import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function PageHeader({ title, to = "/app/more" }) {
  const navigate = useNavigate();
  return (
    <div className="flex items-center gap-3 mb-5">
      <button data-testid="page-back-btn" onClick={() => navigate(to)}
        className="h-9 w-9 rounded-full bg-white shadow-[0_4px_24px_rgba(44,44,62,0.06)] flex items-center justify-center text-[var(--brand-navy)] hover:bg-muted transition-colors shrink-0">
        <ArrowLeft className="h-4 w-4" />
      </button>
      <h1 className="font-heading font-extrabold text-3xl text-[var(--brand-navy)]">{title}</h1>
    </div>
  );
}
